// This file is AUTOGENERATED, do not edit it manually!!!

export const inlineEdit = {
    action_has_been_successfully_redone: '{0} has been successfully redone',
    action_has_been_successfully_undone: '{0} has been successfully undone',
    action_has_not_been_successfully_undone: 'We\'re sorry, but we couldn\'t undo the action.',
    action_will_be_redone_message: 'The action will be redone: {0}',
    action_will_be_undo_message: 'The action will be undone: {0}',
    ActivityChildrenActualHours_Text: 'Time logs for all subactivities:',
    ActivityChildrenEstimatedHours_Text: 'Estimated hours for all subactivities:',
    ActivityOwnBudget_Text: 'Budget for the activity:',
    ActivityOwnEstimatedHours_Text: 'Estimated hours for the activity:',
    ActivitySubactivitiesBudget_Text: 'Budget for all subactivities:',
    ActualCompletion_Text: 'Actual completion',
    ActualHours_Total_Text: 'Actual spent hours, total:',
    AddTimeEntry_Text: 'Add time entry',
    AddUser_Text: 'Invite User',
    AddWeeklyTime_Text: 'Add weekly time',
    Apply: 'Apply',
    Assignees_Text: 'Assignees',
    BudgetedCost_Text: 'Total Project Budget:',
    BudgetPadding_Text: 'Contingency:',
    BudgetTotal_Text: 'Budget, total:',
    Cancel: 'Cancel',
    Close: 'Close',
    Combobox_Add: 'Add ',
    Combobox_KeepTyping: 'Keep typing...',
    Combobox_MultipleSelectDefault: 'Select some options',
    Combobox_NoResults: 'No results',
    Combobox_NoResultsMatch: 'No results match ',
    confirmation_description_dependent_date: 'You are about to change the date of an activity that has dependencies. This action will adjust the dependency lags to align with the new date you provided.',
    confirmation_title_dependent_date: 'This date is linked with a dependent activity',
    Cost_Text: 'Biling:',
    CreateAndSelect: 'Create and select',
    CustomerLabel: 'Customer',
    day_template: '1#{0} day#{0} days',
    Duration_Text: 'Duration',
    EditProjectMembers_Title: 'Project members',
    EditTaskAssignees_Title: 'Assignees',
    End_Text: 'End',
    EndDate_Text: 'End date',
    EstimatedHours_Text: 'Estimated hours:',
    EstimatedHours_Total_Text: 'Estimated hours, total:',
    field_for_all_activities: 'This field is for activities only <b style=\"white-space: nowrap;\">({0} tasks, {1} issues, {2} requests)</b>',
    field_for_issues: 'This field is for <b style=\"white-space: nowrap;\">{0} issues</b> only',
    field_for_projects: 'This field is for <b style=\"white-space: nowrap;\">{0} projects</b> only',
    field_for_requests: 'This field is for <b style=\"white-space: nowrap;\">{0} requests</b> only',
    field_for_tasks: 'This field is for <b style=\"white-space: nowrap;\">{0} tasks</b> only',
    field_for_users: 'This field is for <b style=\"white-space: nowrap;\">users</b> only',
    Hours_Short_Text: 'h',
    HoursLeftLabel: 'Hours left:',
    InternalCost_Text: 'Actual Cost:',
    NonProjectMembers_Text: 'Non project members',
    Not_Space_Members: 'Not members of the space',
    Overloaded_Text: 'Overloaded',
    OwnActualHours_Text: 'Time logs for the activity:',
    PlannedExpenses_Text: 'Planned Expenses:',
    PortfolioLabel: 'Portfolio',
    Progress: 'Progress',
    ProgressCalculatedBySubActivities: 'Based on progress of subactivities',
    ProjectChildrenActualHours_Text: 'Time logs for activities:',
    ProjectChildrenEstimatedHours_Text: 'Estimated hours for all activities:',
    ProjectMembers_Text: 'Project members',
    ProjectOwnBudget_Text: 'Labor Budget for the project:',
    ProjectOwnEstimatedHours_Text: 'Estimated hours for the project:',
    ProjectSubactivitiesBudget_Text: 'Budget for all activities:',
    Space_Members: 'Space members',
    Start_Text: 'Start',
    StartDate_Text: 'Start date',
    Teams_Text: 'Teams',
    Timelogs_In_Past: 'Editing time for an activity that occurred more than {0} in the past is not recommended. Are you sure you want to proceed?',
    Timelogs_In_Past_Short: 'Editing time for an activity that occurred more than {0} in the past is not recommended',
    TimeLogs_Warning_Project_Closed: 'Adding time to a closed project is not recommended. Are you sure you want to proceed with adding time to the closed project?',
    TimeLogs_Warning_Project_Closed_Short: 'Adding time to a closed project is not recommended',
    TimeLogs_Warning_Task_Closed: 'Adding time to a closed activity is not recommended. Are you sure you want to proceed with adding time to this closed activity?',
    TimeLogs_Warning_Task_Closed_Short: 'Adding time to a closed activity is not recommended',
    Tooltip_Dependent_Template: '{0} is linked with a dependent activity and cannot be changed',
    Tooltip_HasChildren_Template: '{0} is calculated based on subactivities and cannot be changed',
    Tooltip_ItemCompleted: 'Cannot be edited since it is linked with a closed activity/project.',
    Tooltip_NoRightForUserRole_Template: '{0} cannot be changed. You have no permission to edit this field',
    Tooltip_Open_Details: 'Please open the details to edit this field',
    undo_action_Project_UpdateActualCompletionDate: 'changing the project actual completion date',
    undo_action_Project_UpdateDates: 'changing the project dates',
    undo_action_Project_UpdateName: 'renaming the project',
    undo_action_Project_UpdateStatus: 'changing the project status',
    undo_action_Task_UpdateActualCompletionDate: 'changing the activity actual completion date',
    undo_action_Task_UpdateDates: 'changing the activity dates',
    undo_action_Task_UpdateDependencies: 'editing the dependency',
    undo_action_Task_UpdateName: 'renaming the activity',
    undo_action_Task_UpdateStatus: 'changing the activity status',
    undo_action_Task_UpdateWorkIsDone: 'setting \'I\'m done\' for task assignment',
    Untitled: 'Untitled',
    Validation_ActComplDateRange: 'Actual completion date doesn\'t fall within the expected range.',
    Validation_DateMandatory: 'Date is a required field.',
    Validation_DurationMandatory: 'Duration is a required field.',
    Validation_EndDateRange: 'End date doesn\'t fall within the expected range.',
    Validation_FieldMandatory: 'This is a required field.',
    Validation_FromDateRange: 'From date doesn\\\'t fall within the expected range.',
    Validation_Interger: 'Value must be integer.',
    Validation_InvalidDate: 'Date must be in \'{0}\' format.',
    Validation_NumberRange: 'Value must be between {0} and {1}.',
    Validation_Range: 'Value doesn\'t fall within the expected range.',
    Validation_StartDateRange: 'Start date doesn\'t fall within the expected range.',
    Validation_ToDateRange: 'To date doesn\\\'t fall within the expected range.',
    Validation_WeekendOrVacation: 'Value mustn\'t fall on a weekend or holiday.',
    Warning_UnassigneFromAllTasksInProject: 'Removed members will be unassigned from all activities in this project.',
    Warning_UnassignFromAllTasksInProject_Single: 'Removed member will be unassigned from all activities in this project.',
};
